import { Component, EventEmitter, Input, Output } from '@angular/core'
import { WebsitePreviewItemContext, WebsitePreviewTab } from './ibranson-preview.iface'

@Component({
  selector: 'app-ib-product-header',
  templateUrl: './ib-product-header.component.html',
  standalone: false,
})
export class IbProductHeaderComponent {
  @Input() cover: string | null = null
  @Input() item: WebsitePreviewItemContext = {}
  @Input() categoryLabel = 'Shows'
  @Input() venueLine = ''
  @Input() showTimeLabel = ''
  @Input() activeTab: WebsitePreviewTab = 'overview'
  @Output() navigate = new EventEmitter<{ event: Event; tab: WebsitePreviewTab }>()

  readonly reviewScore = 4.9
  readonly reviewVotes = 19

  get startingPriceLabel(): string {
    const price = this.item.startingPrice
    if (price == null || !Number.isFinite(price)) {
      return ''
    }
    return `$${price.toFixed(2)}`
  }

  get oldPriceLabel(): string {
    const price = this.item.startingPriceOld
    const sale = this.item.startingPrice
    if (price == null || !Number.isFinite(price) || sale == null || price <= sale) {
      return ''
    }
    return `$${price.toFixed(2)}`
  }

  go(event: Event, tab: WebsitePreviewTab) {
    this.navigate.emit({ event, tab })
  }
}
